// Pill Bar Component (if it's completed it's filled, if not it's empty also it's have number in the middle, it's single item component)

export default function PillBar({isDone, index}: {isDone: boolean; index: number}) {
  return (
    <span
      key={index}
      className={`d-inline-flex align-items-center justify-content-center border border-1 border-secondary rounded-pill text-2xl text-white me-2
         ${isDone ? 'bg-secondary' : 'bg-light text-secondary'}`}
      style={{
        width: '10%',
        height: '20px',
        padding: '10px',
      }}
    >
      {index + 1}
    </span>
  )
}
